<template>
  <div class="dome">
    <van-sticky>
      <shareItem v-show="isShareCome || $route.query && $route.query.sharetype =='browser'" :dlurl="dlurl" pageCode="5010701" v-isNoAppShare/>
      <HeaderH1></HeaderH1>
      <van-search
        v-model="keyWord"
        shape="round"
        background="#FFFFFF"
        placeholder="搜索问问商品名称/分类/标签"
        @search="onSearch"
      />
    </van-sticky>
    <breadcrumb @showTypeFun="showTypeFun" @showNavfun="showNavfun" :NavList="navList" :barnchId="barnchId" :barnchName="barnchName"/>
    <div class="cat0" :class="{'ptb': hengList.length > 0}">
      <div
        :class="['cat1', {'cat1_a': cate.isSelect}]"
        v-for="(cate, index) in hengList"
        :key="index"
        @click="changeCategoryFun(index)"
      >
        {{cate.categoryName}}
        <img
          class="mark"
          v-show="cate.isSelect"
          src="@/assets/image/corner_mark@2x.png"
        />
      </div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text=" " @load="onLoad">
      <atlasItem v-if="JSON.stringify(formData) != '{}'" :showType="showType" @navChange="navChange" :atlasList="formData" />
    </van-list>
    <div class="empty_item" v-if="!isLoading && atlasList.length==0">
      <emptyItem title="该店铺暂未发布问问" />
    </div>
    <!-- <div class="empty_item" v-if="!isLoading && atlasList.length==0 &&  navList.length!=0">
      <emptyItem title="该店铺暂未发布问问" />
    </div> -->
    <!-- <Raad :atlasId="$route.query.atlasId" :branchId="$route.query.brandId"></Raad> -->
    <!-- <div class="index-atlas-bottom">
      <mixedRecoListdata ref="mixedReco" :headerStatus="true" :showStatus="true" :mixedRecoParams="mixedRecoParams"></mixedRecoListdata>
    </div> -->
    <!-- <div class="atlas-index-bottom">
      <div class="atlas-bottom-icons">
        <img src="@/assets/image/brandico.png" />
        <span>分享</span>
      </div> 
      <div class="atlas-bottom-icons" @click="onGetPopupStatus()">
        <img src="@/assets/image/herat1.png" v-show="wishList.length==0" />
        <img src="@/assets/image/herat.png" v-show="wishList.length>0" />
        <span>心愿清单</span>
        <p v-if="wishList.length!=0">{{wishList.length}}</p>
      </div>
      <div class="atlas-bottom-button">
        <div class="atlas-bottom-lefts">
          <span>更多店内新款</span>
          <img src="@/assets/atlas/atlas_bees@2x.png" />
        </div>
        <div class="atlas-bottom-right">
          <img src="@/assets/loading_icon@2x.png" />
          <span>联系蜜蜂</span>
        </div>
      </div> 
    </div> -->
    <div class="index-atlas-button" v-if="navList.length>0">
      <span class="send" @click="onMywantAtlasProduct()">一键分享所有商品</span>
    </div>

    <van-popup v-model="popupStatus" round position="bottom">
      <mywishorder :wishList="wishList" @clearWishOrder="onClearWishOrder" @clearSingeWish="onClearSingeWish" @popupStatus="popupStatus=!popupStatus"></mywishorder>
    </van-popup>
  </div>
</template>
<script>
import HeaderH1 from "@/views/atlas/header/H1";
import Raad from "@/components/atlas/read";
import breadcrumb from "@/components/atlas/breadcrumb";
import atlasItem from "@/components/atlas/atlasItem";
import mywishorder from "@/components/atlas/mywishorder";
import emptyItem from '@/views/shareDiscovery/components/emptyItem';
// import mixedRecoListdata from '@/components/mixedReco/mixedRecoListdata';
import http from "@/utils/axios";
import shareItem from '@/views/shareDiscovery/components/shareBtn'
import { isWeChatApplet } from "@/utils/util";
import utils from "@/utils/common";
export default {
  data() {
    return {
      showType: "itemTwo",
      navList: [],
      popupStatus: false,
      wishList: [],
      atlasList: [],
      queryData: {},
      shareTitle: "",
      loading: false,
      finished: false,
      pageIndex: 1,
      barnchId:'',
      barnchName:'',
      mixedRecoParams: {},
      isLoading: true,
      formData:{},
      keyWord:'',
      hengList:[]
    };
  },
  components: { breadcrumb, atlasItem, mywishorder, HeaderH1, Raad, emptyItem ,shareItem},
  created() {
    //this.$loading.hide();
    this.onGetNavatlas();
    // this.onGetWishData();
    this.getHengList();
  },
  methods: {
    // 展示方式
    showTypeFun(type) {
      switch (type) {
        case "m2":
          this.showType = "itemTwo";
          break;
        case "m3":
          this.showType = "itemOne";
          break;
        default:
          this.showType = "itemDefault";
          break;
      }
    },
    // 页眉点击
    showNavfun(obj) {
      let length = this.navList.length;
      this.navList.splice(obj.index + 1, length);
      this.queryData = obj.item;
      this.queryData.atlasId = obj.item.id || obj.item.atlasId;
      this.pageIndex = 1;
      this.$loading.show();
      this.onGetatlasDataList();
    },
    onLoad() {
      this.onGetatlasDataList();
    },
    // 图集项点击
    navChange(item) {
      this.navList.push(item);
      this.queryData = {
        ...item
      };
      this.queryData.atlasId = item.id || item.atlasId;
      this.queryData.shareId=null;
      this.pageIndex = 1;
      this.onGetatlasDataList();
    },
    onGetPopupStatus: function () {
      this.popupStatus = !this.popupStatus
      this.onGetWishData()
    },
    onGetWishData: function() {
      http({
        url: "discover/appuser/wishlist/list",
        method: "post",
        parmes: {
          shareId: this.$route.query.shareId
        }
      }).then(res => {
        if (res.code == 200 && res.data) {
          this.wishList = res.data
        }
      });
    },
    onClearWishOrder: function () {
      http({
        url: "/discover/appuser/wishlist/clear",
        method: "post",
        parmes: {
          shareId: this.$route.query.shareId
        }
      }).then(res => {
        if (res.code == 200) {
          this.onGetWishData();
        }
      });
    },
    onClearSingeWish: function (event) {
      http({
        url: "/discover/appuser/wishlist/item/delete",
        method: "post",
        parmes: {
          id: event.id
        }
      }).then(res => {
        if (res.code == 200) {
          this.onGetWishData();
        }
      });
    },
    // 获取图集
    onGetatlasDataList() {
      let arr = this.hengList.filter((item) =>{return item.isSelect}).map((item)=>{return item.categoryId});
      let parmes = {
        atlasId: this.$route.query.atlasId,
        branchId: this.$route.query.brandId,
        pageIndex: 1,
        pageSize: 100000,
        atlasType:'0',
        shareId: this.$route.query.shareid,
        ...this.queryData,
        categoryIds: arr,
        keyWord: this.keyWord || ''
      };
      this.http({
        url: "/discover/appbees/atlas/list",
        method: "post",
        parmes: parmes
      }).then(rps => {
        if (rps.code === 200) {
          if (this.pageIndex == 1 && rps.data.list) {
            this.atlasList = rps.data.list;
          } else if(rps.data && rps.data.list){
            this.atlasList = this.atlasList.concat(rps.data.list);
          }
          if (rps.data.isLastPage || rps.data.list.length==0) {
            this.finished = true;
          } else {
            this.finished = false;
            this.pageIndex++;
          }

          this.formData = {};
          this.atlasList.forEach(element => {
            if(this.formData[element.showTimeStr]){
              this.formData[element.showTimeStr].push(element)
            }else{
              this.formData[element.showTimeStr] = [element]
            }
          });
          //console.log(this.formData)
        }
        this.isLoading = false;
        this.$loading.hide();
      });
    },
    // 获取页眉
    onGetNavatlas() {
      let parmes = {}
      if(this.$route.query.shareid){
        parmes.shareTempId=this.$route.query.shareid;
      }else{
        parmes.branchId= this.$route.query.brandId;
      }
      this.http({
        url:"/discover/appbees/atlas/atlasShareTitle",
        method: "post",
        parmes:parmes
      }).then(rps => {
        this.$loading.hide();
        this.navList = rps.data.catalog;
        this.barnchId = rps.data.branchId;
        this.barnchName = rps.data.barnchName;
        this.mixedRecoParams = rps.data.recommends ? rps.data.recommends : {};
        // this.$refs.mixedReco.onGetMixedRecoData()
        setTimeout(() => {
          this.isLoading = false
        }, 1000);
      });
      // this.onGetatlasDataList();
    },
    onMywantAtlasProduct: function () { // 分享
      //console.log(111111)
      this.$minicode.show({pageCode:'5010902',pageQueryParam:this.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
      utils.nativeMethod({
        tm: 4050101,
        tp: {
          tempAtlasId: this.navList[0].id,
          branchId: this.navList[0].branchId,
          branchName: '',
          beesId: this.navList[0].beesId,
          beesName: this.navList[0].nickname
        }
      })
    },
    //获取横向滑动的入参条件
    getHengList(){
      this.http({
        url: "discover/appbees/atlas/searchList",
        method: "post",
        parmes: {"branchId": this.$route.query.brandId,shareId:this.$route.query.shareid}
      }).then(rps => {
        if (rps.code === 200) {
          this.hengList = rps.data.categoryList || [];
          this.hengList.forEach(element => {
            element.isSelect = false;
          });
        }
        this.$loading.hide();
      });
    },
    //点击入参条件
    changeCategoryFun(index) {
      this.$set(this.hengList[index], "isSelect", !this.hengList[index].isSelect);
      this.atlasList = [];
      this.$loading.show();
      this.isLoading = true;
      this.onGetatlasDataList();
    },
    //关键字搜索
    onSearch(val){
      this.keyWord = val.replace(/\s/g,"");
      this.atlasList = [];
      this.$loading.show();
      this.onGetatlasDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.dome{
  background-color: #F7F7F7;
}
.empty_item{
  background-color: #fff;
  padding: 50px 0;
  margin: 20px 20px;
  border-radius: 20px;
}
.atlas-index-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 98px;
  padding-left: 20px;
  padding-right: 40px;
  background-color: white;
}
.atlas-bottom-icons {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90px;
}
.atlas-bottom-icons img {
  width: 44px;
  height: 44px;
}
.atlas-bottom-icons span {
  font-size: 20px;
  padding-top: 10px;
}
.atlas-bottom-icons p {
  position: absolute;
  top: 0;
  right: 10px;
  height: 28px;
  min-width: 20px;
  border-radius: 28px;
  color: white;
  font-size: 20px;
  text-align: center;
  padding: 0 4px;
  background-color: #e74a4a;
}
.atlas-bottom-button {
  width: 471px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
  background-color: #333333;
  border-radius: 70px;
  overflow: hidden;
}
.atlas-bottom-lefts {
  display: flex;
  align-items: center;
  padding-left: 28px;
}
.atlas-bottom-lefts span {
  color: white;
  font-size: 28px;
  font-weight: bolder;
}
.atlas-bottom-lefts img {
  width: 36px;
  height: 29px;
  margin-left: 15px;
}
.atlas-bottom-right {
  display: flex;
  align-items: center;
  padding: 0 6px;
  border-radius: 58px;
  width: 192px;
  height: 58px;
  background-color: #f8d541;
}
.atlas-bottom-right img {
  display: block;
  width: 46px;
  height: 46px;
  border-radius: 46px;
  object-fit: cover;
}
.atlas-bottom-right span {
  font-size: 26px;
  font-weight: bolder;
  padding-left: 10px;
}
.index-atlas-button{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: white;
  height: 98px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 30px;
}
.index-atlas-button .send{
  flex: 1;
  height:76px;
  background:rgba(248,213,65,1);
  border-radius:76px;
  text-align: center;
  line-height: 76px;
  font-size: 26px;
  margin-left: 30px;
}
.index-atlas-bottom{
  display: block;
  padding-bottom: 98px;
}
.cat0 {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-left: 30px;
  &::-webkit-scrollbar {
    display: none;
  }
  .mark {
    width: 29px;
    height: 29px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .cat1.cat1_a {
    color: #f8a651;
    border-color: #f8a651;
  }
  .cat1:first-child {
    margin-left: 0;
  }
  .cat1 {
    flex-shrink: 0;
    height: 50px;
    padding: 0 28px;
    color: #999;
    border-radius: 10px;
    border: 2px solid #999;
    box-sizing: border-box;
    font-size: 24px;
    line-height: 50px;
    position: relative;
    background-color: #fff;
    margin-left: 20px;
  }
}
.ptb{
  padding-top: 25px;
  padding-bottom: 25px;
}
</style>